import {inject, Injectable, Type} from '@angular/core';
import {defaultDescription, defaultTitle} from "../app.routes";
import {articles, esArticles} from "homey-housing-lottery-app-dto";
import {TranslateService} from "./translate.service";
import {
  MathiasInesArticleComponent
} from "../pages/custom-articles/mathias-ines-article/mathias-ines-article.component";
import {BiancaArticleComponent} from "../pages/custom-articles/bianca-article/bianca-article.component";

@Injectable({
  providedIn: 'root'
})
export class ArticleService {
  private readonly translateService = inject(TranslateService)
  private readonly customArticleComponents: Record<string, Type<unknown>> = {
    'mathias-ines-story': MathiasInesArticleComponent,
    'bianca-story': BiancaArticleComponent
  };

  public getArticle(id: string) {
    const article = this.getArticles().find(article => article.slug === id);
    return article;
  }

  public getCustomComponent(id: string | null) {
    if (!id) return undefined;
    return this.customArticleComponents[id];
  }

  public hasArticle(id: string) {
    return !!this.getArticles().find(article => article.slug === id);
  }

  public getArticles() {
    if(this.translateService.language() === 'es') {
      return esArticles;
    } else {
      return articles;
    }
  }

  public getArticleTitle(id: string | null) {
    if (!id) {
      return defaultTitle;
    }
    const article = this.getArticle(id);

    return article ? `${article.title} - Homey NYC` : defaultTitle;
  }

  public getArticleDescription(id: string | null) {
    if (!id) {
      return defaultDescription;
    }

    const article = this.getArticle(id);

    return article ? article.description : defaultDescription;
  }
}
